<template>
<div class="chapter">
<div class="inner_page">
<p class="title">W<span class="small2">HAT</span> S<span class="small2">TALIN</span><br/>K<span class="small2">NEW</span></p>
<p class="subtitle"><span class="small2">THE</span><br/>E<span class="small2">NIGMA OF</span><br/>B<span class="small2">ARBAROSSA</span></p>
<p class="author">David E. Murphy</p>
<p>Yale University Press   New Haven &amp; London</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?233f5474